import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import TypeIt from "typeit-react";
import MetaTagsSeo from "../../components/Shared/MetaTagsSeo";
import {
  cardVariants,
  imageContainer,
  imageItem,
} from "../../styles/animationVars";
import "./IndexPage.scss";
export default function GlobalIndexPage() {
  return (
    <>
      {/* meta sections */}
      <MetaTagsSeo
        title="FROI – GlobalIndex"
        description="Government Human Capital Future Readiness Index™
Grounded in an advanced Human Capital Future Readiness Model, FROI’s Government Human Capital Future Readiness Index is engineered to drive meaningful institutional impact by assessing how effectively government entities manage, transform, and align their human capital ecosystem with emerging global future scenarios and national strategic government visions."
        keywords={[
          "FUTURE READY ORGANIZATION INSTITUTE",
          "Future Ready",
          "Future Ready Organization",
          "Future Ready Government",
          "Future Readiness Standards for Government Human Capital Practices",
          "Human Capital Future Readiness",
          "Future Readiness Index",
          "Government Human Capital Future Readiness Accreditation",
          "Future Readiness Accreditation",
          "Government Human Capital Future Readiness Index",
          "Future Readiness Research & Studies",
          "FROI's Future Ready Government Human Capital Model",
        ].join(", ")}
        OGDescription="FROI Accreditation is not merely a compliance milestone; it is a global declaration of Governmental Human Capital Future Readiness."
        url="https://www.froiglobal.org/"
      />{" "}
      {/* branding section */}
      <motion.section className="froi_section">
        {/* <section className="froi_section"> */}
        <Container>
          <TypeIt
            element="h1"
            className="froi_title"
            options={{
              speed: 50,
              waitUntilVisible: true,
              cursor: false,
              lifeLike: true,
            }}
          >
            FROI’s Global <span className="marked_word">Index</span>
          </TypeIt>
          <div>
            <TypeIt
              element="h2"
              className="froi_subtitle"
              options={{
                speed: 50,
                waitUntilVisible: true,
                cursor: false,
                lifeLike: true,
              }}
            >
              <strong>
                <span className="marked_word">
                  Government Human Capital Future Readiness Index
                </span>
                ™
              </strong>
            </TypeIt>
          </div>
          <Row className="froi_brand_section">
            <Col lg={6} xs={12}>
              <div className="froi_brand_text">
                <p className="froi_text ">
                  {/* <strong>
                    <span className="marked_word">
                      Government Human Capital Future Readiness Index
                    </span>
                    ™
                  </strong> */}
                  {/* <br /> */}
                  Grounded in an advanced Human Capital Future Readiness Model,
                  FROI’s Government Human Capital Future Readiness Index is
                  engineered to drive meaningful institutional impact by
                  assessing how effectively government entities manage,
                  transform, and align their human capital ecosystem with
                  emerging global future scenarios and national strategic
                  government visions.
                </p>
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <motion.div
                className="froi_brand_img"
                initial={{
                  opacity: 0,
                  x: 80,
                  scale: 0.75,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  scale: 1,
                }}
                transition={{
                  duration: 1,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                <img
                  src={"./images/GlobalIndex/Index_Logo.png"}
                  alt={"Froi_Global_Index"}
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </motion.section>
      {/* meassges section */}
      <section className="froi_section messages_section">
        <Container>
          <Row>
            <Col lg={4} xs={12}>
              <motion.img
                className="Index_message"
                src="./images/GlobalIndex/Index_page_message_1.png"
                alt="Froi_GlobalIndex_page_message"
                variants={cardVariants}
                custom={0}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.25 }}
              />
            </Col>
            <Col lg={4} xs={12}>
              <motion.img
                className="Index_message"
                src="./images/GlobalIndex/Index_page_message_2.png"
                alt="Froi_GlobalIndex_page_message_2"
                variants={cardVariants}
                custom={1}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.25 }}
              />
            </Col>
            <Col lg={4} xs={12}>
              <motion.img
                className="Index_message"
                src="./images/GlobalIndex/Index_page_message_3.png"
                alt="Froi_GlobalIndex_page_message_3"
                variants={cardVariants}
                custom={2}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.25 }}
              />
            </Col>
          </Row>
          <div>
            <p className="froi_text_large">
              <strong className="marked_word">
                Built upon 15 Foundational Pillars, the Index provides a
                comprehensive reference for..
              </strong>
            </p>
          </div>
        </Container>
      </section>
      {/* cards sections */}
      <section className="froi_section cards_section">
        <Container>
          <motion.div
            className="froi-index-cards"
            variants={imageContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{
              //once: true,
              amount: 0.25,
            }}
          >
            <Row>
              <Col lg={4} xs={12}>
                <motion.img
                  variants={imageItem}
                  className="Index_message"
                  src="./images/GlobalIndex/Index_page_card_1.png"
                  alt="Froi Index page card 1"
                />
              </Col>

              <Col lg={4} xs={12}>
                <motion.img
                  variants={imageItem}
                  className="Index_message"
                  src="./images/GlobalIndex/Index_page_card_2.png"
                  alt="Froi Index page card 2"
                />
              </Col>

              <Col lg={4} xs={12}>
                <motion.img
                  variants={imageItem}
                  className="Index_message"
                  src="./images/GlobalIndex/Index_page_card_3.png"
                  alt="Froi Index page card 3"
                />
              </Col>
            </Row>
          </motion.div>
        </Container>
      </section>
    </>
  );
}
